// eslint-disable-next-line
export const SHARED_STATE = {
    FILTER_STRING: '',
};
